<script lang="ts" setup>
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})
</script>

<template>
  <StrapiSlice
    v-if="slice?.Items?.length"
    class="ct-faq"
    :slice="slice"
    :index="index"
  >
    <UiCollapsable
      v-for="(item) in slice.Items"
      :key="item.Question"
      :label="item.Question"
    >
      <template #icon_after="{ open }">
        <Icon
          :name="open ? 'icon:min' : 'icon:plus'"
          class="collapsable__icon icon icon--min"
          :class="`icon--${open ? 'min' : 'plus'}`"
        />
      </template>

      <StrapiBlocksText
        v-if="item?.Answer?.length"
        :nodes="item.Answer"
      />
    </UiCollapsable>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/Faq.css");
</style>
